// @ts-nocheck
export const MODEL_NAME = 'tableColumns';
